module.exports = __webpack_public_path__ + "static/quicklens-a17fea96913557d5b49f0eb2d581a6d2.png";